import { V4 } from '@moleculeone/utils';

export function BondLine(props: any) {
  const { className, backgroundClassName, pos1, pos2, bgColor, bgOpacity, color, single } = props;

  const bg1 = V4.affine(pos1, 0.05, pos2);
  const bg2 = V4.affine(pos2, 0.05, pos1);

  return (
    <>
      <line
        x1={bg1[0].toFixed(2)}
        y1={bg1[1].toFixed(2)}
        x2={bg2[0].toFixed(2)}
        y2={bg2[1].toFixed(2)}
        strokeWidth={single ? '25px' : '15.5px'}
        strokeLinecap="butt"
        stroke={bgColor}
        opacity={bgOpacity}
        className={backgroundClassName}
      />
      <line
        x1={pos1[0].toFixed(2)}
        y1={pos1[1].toFixed(2)}
        x2={pos2[0].toFixed(2)}
        y2={pos2[1].toFixed(2)}
        strokeWidth="4.5px"
        strokeLinecap="round"
        stroke={color}
        className={className}
      />
    </>
  );
}

// Line.propTypes = {
//   ...bondLineShape,
//   className: PropTypes.string,
//   backgroundClassName: PropTypes.string,
//   single: PropTypes.bool,
// };
